/* [Modified by Codex at 2026-09-15] 按当前及相邻幻灯片加载产品主图，避免重复图库一次下载全部大图 */
(() => {
  "use strict";

  const gallerySelector = ".product__media-gallery";
  const deferredMainSelector = "img[data-product-media-srcset]";
  const deferredThumbnailSelector = "img[data-product-thumbnail-srcset]";
  const deferredSelector = `${deferredMainSelector}, ${deferredThumbnailSelector}`;
  const swiperSelectors = [
    ".swiper.bls__product-gallery:not(.bls__swiper-gallery-thumbnails)",
    ".swiper.bls__swiper-gallery-thumbnails",
    ".swiper.bls__swiper-gallery-thumbnails-mobile",
  ];
  const swiperSelector = swiperSelectors.join(", ");
  const gallerySwiperSelector = swiperSelectors
    .map((selector) => `${gallerySelector} ${selector}`)
    .join(", ");
  const initializedAttribute = "data-vedress-media-lazy-initialized";
  let gridObserver;
  let resizeFrame;

  function isVisible(element) {
    return Boolean(
      element &&
        element.getClientRects().length &&
        element.getBoundingClientRect().width > 0,
    );
  }

  function markImageLoaded(image) {
    if (!image || image.naturalWidth <= 1) return;

    image.classList.add("bls-loaded-image");
    image
      .closest(".product-media-loading-placeholder")
      ?.classList.add("product-media-is-loaded");
    image.closest(".bls-image-js")?.classList.remove("bls-loading-image");
  }

  function watchImageLoad(image) {
    if (!image || image.dataset.vedressProductLoadWatched === "true") return;

    image.dataset.vedressProductLoadWatched = "true";
    image.addEventListener("load", () => markImageLoaded(image));

    if (image.complete && image.naturalWidth > 1) {
      markImageLoaded(image);
    }
  }

  function hydrateImage(image) {
    if (!image) return;

    const sourceSet =
      image.dataset.productMediaSrcset || image.dataset.productThumbnailSrcset;
    const source = image.dataset.productMediaSrc || image.dataset.productThumbnailSrc;
    if (!sourceSet) return;

    watchImageLoad(image);
    image.dataset.vedressProductMediaHydrated = "true";
    delete image.dataset.productMediaSrcset;
    delete image.dataset.productMediaSrc;
    delete image.dataset.productThumbnailSrcset;
    delete image.dataset.productThumbnailSrc;
    image.srcset = sourceSet;
    if (source) image.src = source;

    if (image.complete && image.naturalWidth > 1) {
      markImageLoaded(image);
    }
  }

  function hydrateSlide(slide) {
    slide?.querySelectorAll(deferredSelector).forEach(hydrateImage);
  }

  function hydrateAround(swiper) {
    if (!isVisible(swiper)) return;

    const swiperBounds = swiper.getBoundingClientRect();
    const renderedSlides = Array.from(swiper.querySelectorAll(".swiper-slide")).filter(
      (slide) => {
        const slideBounds = slide.getBoundingClientRect();
        return (
          slideBounds.width > 0 &&
          slideBounds.height > 0 &&
          slideBounds.right > swiperBounds.left &&
          slideBounds.left < swiperBounds.right &&
          slideBounds.bottom > swiperBounds.top &&
          slideBounds.top < swiperBounds.bottom
        );
      },
    );
    let activeSlides = Array.from(
      swiper.querySelectorAll(".swiper-slide-active, .swiper-slide-visible"),
    );

    renderedSlides.forEach((slide) => {
      if (!activeSlides.includes(slide)) activeSlides.push(slide);
    });

    if (!activeSlides.length) {
      const firstSlide = swiper.querySelector(".swiper-slide");
      if (firstSlide) activeSlides = [firstSlide];
    }

    activeSlides.forEach((slide) => {
      hydrateSlide(slide.previousElementSibling);
      hydrateSlide(slide);
      hydrateSlide(slide.nextElementSibling);
    });
  }

  function initializeSwiper(swiper) {
    if (swiper.hasAttribute(initializedAttribute)) return;
    swiper.setAttribute(initializedAttribute, "true");

    hydrateAround(swiper);

    if (!("MutationObserver" in window)) {
      if (isVisible(swiper)) {
        swiper.querySelectorAll(deferredSelector).forEach(hydrateImage);
      }
      return;
    }

    let updateFrame;
    const observer = new MutationObserver((records) => {
      if (!records.some((record) => record.target.classList?.contains("swiper-slide"))) {
        return;
      }

      cancelAnimationFrame(updateFrame);
      updateFrame = requestAnimationFrame(() => hydrateAround(swiper));
    });

    observer.observe(swiper.querySelector(".swiper-wrapper") || swiper, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true,
    });
  }

  function getGridObserver() {
    if (!("IntersectionObserver" in window)) return null;
    if (gridObserver) return gridObserver;

    gridObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          hydrateImage(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "400px 0px" },
    );

    return gridObserver;
  }

  function initializeGridImages(scope) {
    const observer = getGridObserver();

    scope.querySelectorAll(deferredMainSelector).forEach((image) => {
      if (image.closest(".swiper")) return;

      if (!observer) {
        hydrateImage(image);
        return;
      }

      observer.observe(image);
    });
  }

  function initialize(scope = document) {
    const galleries = [];

    if (scope.matches?.(gallerySelector)) galleries.push(scope);
    scope.querySelectorAll?.(gallerySelector).forEach((gallery) => galleries.push(gallery));

    galleries.forEach((gallery) => {
      gallery
        .querySelectorAll(swiperSelector)
        .forEach(initializeSwiper);

      gallery
        .querySelectorAll(".product-media-loading-placeholder img")
        .forEach(watchImageLoad);
      initializeGridImages(gallery);
    });
  }

  function refreshVisibleGalleries() {
    document
      .querySelectorAll(gallerySwiperSelector)
      .forEach(hydrateAround);
  }

  initialize();

  window.addEventListener(
    "resize",
    () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(refreshVisibleGalleries);
    },
    { passive: true },
  );

  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
})();
/* [End] */
